<span *ngIf="typeMessage">
  <span class="badge badge-info">{{ typeMessage | translate }}</span>
</span>
